import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-657f593a")

_pushScopeId("data-v-657f593a")
const _hoisted_1 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "subdate" }, " year ", -1)
const _hoisted_4 = {
  key: 0,
  class: "daily-view"
}
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { class: "table is-bordered is-fullwidth is-narrow is-hoverable" }
const _hoisted_7 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", null, "User"),
  /*#__PURE__*/_createVNode("th", null, "Accepted Paid Absence"),
  /*#__PURE__*/_createVNode("th", null, "Planned Paid Absence"),
  /*#__PURE__*/_createVNode("th", null, "Accepted Unpaid Absence"),
  /*#__PURE__*/_createVNode("th", null, "Planned Unpaid Absence"),
  /*#__PURE__*/_createVNode("th", null, "Accepted Special Absence"),
  /*#__PURE__*/_createVNode("th", null, "Planned Special Absence"),
  /*#__PURE__*/_createVNode("th", null, "Course/Conference"),
  /*#__PURE__*/_createVNode("th", null, "Total unavailability")
], -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-spin fa-sync-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Loading...")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_time_switcher = _resolveComponent("time-switcher")
  const _component_user_row = _resolveComponent("user-row")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("p", null, _toDisplayString(_ctx.selectedYearMessage), 1),
    _hoisted_1,
    _createVNode("div", null, [
      _createVNode(_component_time_switcher, {
        onPrev: _ctx.previousYear,
        onNext: _ctx.nextYear
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.format(_ctx.currentDate, 'yyyy')) + " ", 1),
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onPrev", "onNext"]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("table", _hoisted_6, [
                _hoisted_7,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createBlock(_component_user_row, {
                    key: user.id,
                    user: user
                  }, null, 8, ["user"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})